import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_RECOMMENDATIONS = apiPromiseTypes('products-recommendations-for-you', 'get');
